<template>
  <modal :closeModal="closeModal">
    <slot></slot>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  name: 'CourseModal',
  components: {
    Modal
  },
  props: {
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    }
  }
}
</script>
